import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import { Retailer_Network_User_Role } from '@occc/graphql';

type RetailerNetworkUserTableChangeRoleDropdownProps = {
  userRole: Retailer_Network_User_Role;
  onRoleChange: (userRole: Retailer_Network_User_Role) => void;
  isRetailerNetworkUserUpdateInProgress: boolean;
  userRolesOptions: { label: string; role: Retailer_Network_User_Role }[];
};

const RetailerNetworkUserRoleDropdownMenu = ({
  onRoleChange,
  userRole,
  userRolesOptions,
  isRetailerNetworkUserUpdateInProgress,
}: RetailerNetworkUserTableChangeRoleDropdownProps) => {
  return (
    <FormControl variant='standard'>
      <Select
        value={userRole}
        // We need to stop propagation here to prevent the event from bubbling up to the TableRow component
        // After we stop use link for the whole TableRow component (tbd with FE team) it should be removed
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={(event) => onRoleChange(event.target.value as Retailer_Network_User_Role)}
        disabled={isRetailerNetworkUserUpdateInProgress}
      >
        {userRolesOptions.map((option) => (
          <MenuItem key={option.label} value={option.role}>
            <Typography variant='body2' component='span'>
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RetailerNetworkUserRoleDropdownMenu;
